<div class="mat-dialog-containers">
    <div mat-dialog-title class="mat-dialog-title">
        <mat-icon *ngIf="showIcon" [ngStyle]="{'color':iconColor}">{{iconType}}</mat-icon>
        <span class="mat-dialog-title-style">{{title}}</span>
    </div>

    <div mat-dialog-content class="mat-dialog-content">
        <p>{{message}}</p>
    </div>

    <div mat-dialog-actions class="mat-dialog-actions row">
        <button class="btn button-confirm-style" (click)="buttonOneClick()">{{textButtonOne}}</button>
        <button *ngIf="!isOneButton" class="btn button-cancel-style"
            (click)="buttonTwoClick()">{{textButtonTwo}}</button>
    </div>
</div>